import { Group, Image, Stack, Text, useComputedColorScheme } from "@mantine/core";
import { useTranslation } from "react-i18next";

const SCALE_STEPS = Array.from({ length: 9 }, (_value, index) => index);
const TILE_SIZE = 18;

export default function GrayScaleLegend() {
  const { t } = useTranslation();
  const colorScheme = useComputedColorScheme("light");

  return (
    <Stack gap={2} align="center">
      <Text fz="sm" fw={600} ta="center">
        {`${t("absoluteSensitivity", "Absolute Sensitivity")} (dB)`}
      </Text>
      <Group
        gap={0}
        wrap="nowrap"
        style={colorScheme === "dark" ? { filter: "invert(1)" } : undefined}
      >
        {SCALE_STEPS.map((step) => (
          <Image
            key={step}
            src={`img/new_db_images/${step}.png`}
            w={TILE_SIZE}
            h={TILE_SIZE}
            alt={`${step * 5} dB`}
          />
        ))}
      </Group>
      <Group justify="space-between" w={TILE_SIZE * SCALE_STEPS.length} gap={0}>
        <Text fz="xs">0</Text>
        <Text fz="xs">40 dB</Text>
      </Group>
    </Stack>
  );
}
